import React, { useState } from "react";
import OtpModal from "./OtpModal";
import TextInput from "./shared/TextInput";
import DateInput from "./shared/DateInput";
import Checkbox from "./shared/Checkbox";
import SelectInput from "./shared/SelectInput";
import NumberInput from "./shared/NumberInput";
import NotificationModal from "./NotificationModal";
import { PostRequestOtp, PostScheduledData, PostVerifyOtp } from "../apis/post";
import TimeInput from "./shared/TimeInput";
import AcknowledgeComponent from "./AcknowledgeComponent";
import TimePicker from "./shared/TimePicker";
import {
  formatEstDate,
  getEstDateTime,
  getLocalItem,
  setLocalItem,
} from "../../utilities/util";
import { host } from "../../services/api";

interface ScheduleFormData {
  employeeName: string;
  requestDate: string;
  restaurantLocation: string;
  scheduleChangeRequested: boolean;
  shiftDropRequested: boolean;
  dropDate: string;
  dropHours: string;
  replacementName: string;
  shiftPickRequested: boolean;
  pickDate: string;
  pickHours: string;
  scheduledEmployee: string;
  requestedDayOff: boolean;
  dayOffFrom: string;
  dayOffTo: string;
  dayOffReason: string;
  isVolunteer: boolean;
  followingShiftChangeRequest: boolean;
  followingShiftDate: string;
  followingShiftHoursFrom: string;
  followingShiftHoursTo: string;
  followingShiftPosition: string;
  mobileNumber: string;
  countryCode: string;
  acknowledge: boolean;
}
console.log(formatEstDate(getEstDateTime()));
console.log(getEstDateTime);
const ScheduleRequestForm: React.FC = () => {
  const [form, setForm] = useState<ScheduleFormData>({
    employeeName: "",
    requestDate: `${formatEstDate(getEstDateTime())}`,
    restaurantLocation: "",
    scheduleChangeRequested: false,
    shiftDropRequested: false,
    dropDate: "",
    dropHours: "",
    replacementName: "",
    shiftPickRequested: false,
    pickDate: "",
    pickHours: "",
    scheduledEmployee: "",
    requestedDayOff: false,
    dayOffFrom: "",
    dayOffTo: "",
    dayOffReason: "",
    isVolunteer: false,
    followingShiftChangeRequest: false,
    followingShiftDate: "",
    followingShiftHoursFrom: "",
    followingShiftHoursTo: "",
    followingShiftPosition: "",
    mobileNumber: "",
    countryCode: "+1",
    acknowledge: false,
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showNotice, setShowNotice] = useState({ state: false, message: "" });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, type, value } = e.target;
    const isCheckbox = type === "checkbox";
    let finalValue = isCheckbox
      ? (e.target as HTMLInputElement).checked
      : value;

    if (type === "date" && value) {
      const formattedDate = new Date(value).toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
      finalValue = formattedDate;
    }

    console.log(finalValue)
    if (name === "scheduleChangeRequested") {
      setForm({
        ...form,
        requestedDayOff: false,
        dayOffFrom: "",
        dayOffTo: "",
        dayOffReason: "",
        followingShiftChangeRequest: false,
        followingShiftDate: "",
        followingShiftHoursFrom: "",
        followingShiftHoursTo: "",
        followingShiftPosition: "",
      });
    }

    if (name === "requestedDayOff") {
      setForm({
        ...form,
        scheduleChangeRequested: false,
        shiftDropRequested: false,
        dropDate: "",
        dropHours: "",
        replacementName: "",
        shiftPickRequested: false,
        pickDate: "",
        pickHours: "",
        scheduledEmployee: "",
        followingShiftChangeRequest: false,
        followingShiftDate: "",
        followingShiftHoursFrom: "",
        followingShiftHoursTo: "",
        followingShiftPosition: "",
      });
    }

    if (name === "followingShiftChangeRequest") {
      setForm({
        ...form,
        scheduleChangeRequested: false,
        shiftDropRequested: false,
        dropDate: "",
        dropHours: "",
        replacementName: "",
        shiftPickRequested: false,
        pickDate: "",
        pickHours: "",
        scheduledEmployee: "",
        requestedDayOff: false,
        dayOffFrom: "",
        dayOffTo: "",
        dayOffReason: "",
      });
    }
    if (name === "shiftDropRequested") {
      setForm({
        ...form,
        shiftPickRequested: false,
        pickDate: "",
        pickHours: "",
        scheduledEmployee: "",
      });
    }

    if (name === "shiftPickRequested") {
      setForm({
        ...form,
        shiftDropRequested: false,
        dropDate: "",
        dropHours: "",
        replacementName: "",
      });
    }

    setForm((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
  };

  const handleSendOtp = async () => {
    if (!form.employeeName.trim()) {
      showTemporaryNotice({
        state: true,
        message: "Employee Name is required!",
      });
      return;
    }
    if (!form.requestDate.trim()) {
      showTemporaryNotice({
        state: true,
        message: "Date of Request is required!",
      });
      return;
    }
    if (!form.restaurantLocation.trim()) {
      showTemporaryNotice({
        state: true,
        message: "Restaurant Location is required!",
      });
      return;
    }

    if (form.scheduleChangeRequested) {
      if (!form.shiftDropRequested && !form.shiftPickRequested) {
        showTemporaryNotice({
          state: true,
          message: "Please select at least one option! Drop or Pick up Shift",
        });
        return;
      }

      if (form.shiftDropRequested) {
        if (!form.dropDate.trim()) {
          showTemporaryNotice({
            state: true,
            message: "Drop Date is required when dropping shift!",
          });
          return;
        }
        if (!form.dropHours.trim()) {
          showTemporaryNotice({
            state: true,
            message: "Drop Hours is required when dropping shift!",
          });
          return;
        }
        if (!form.replacementName.trim()) {
          showTemporaryNotice({
            state: true,
            message: "Replacement Name is required when dropping shift!",
          });
          return;
        }
      }

      if (form.shiftPickRequested) {
        if (!form.pickDate.trim()) {
          showTemporaryNotice({
            state: true,
            message: "Pick Date is required when picking up shift!",
          });
          return;
        }

        if (!form.pickHours.trim()) {
          showTemporaryNotice({
            state: true,
            message: "Pick Hours is required when picking up shift!",
          });
          return;
        }
        if (!form.scheduledEmployee.trim()) {
          showTemporaryNotice({
            state: true,
            message: "Scheduled Employee is required when picking up shift!",
          });
          return;
        }
      }
    }

    if (form.requestedDayOff) {
      if (!form.dayOffFrom.trim()) {
        showTemporaryNotice({ state: true, message: "From Date is required!" });
        return;
      }

      if (!form.dayOffTo.trim()) {
        showTemporaryNotice({ state: true, message: "To Date is required!" });
        return;
      }

      if (!form.dayOffReason.trim()) {
        showTemporaryNotice({ state: true, message: "Reason is required!" });
        return;
      }
    }

    if (form.followingShiftChangeRequest) {
      if (!form.followingShiftDate.trim()) {
        showTemporaryNotice({
          state: true,
          message: "Thrid dropdown date is required!",
        });
        return;
      }

      if (!form.followingShiftHoursFrom.trim()) {
        showTemporaryNotice({ state: true, message: "Hour From is required!" });
        return;
      }

      if (!form.followingShiftHoursTo.trim()) {
        showTemporaryNotice({ state: true, message: "Hour To is required!" });
        return;
      }

      if (!form.followingShiftPosition.trim()) {
        showTemporaryNotice({ state: true, message: "Position is required!" });
        return;
      }
    }

    if (form.mobileNumber.trim().length !== 10) {
      showTemporaryNotice({
        state: true,
        message: "Please enter a valid 10-digit mobile number.",
      });
      return;
    }

    const _res = await PostRequestOtp({
      phone: form.countryCode + form.mobileNumber,
      type: "s",
    });
    if (_res.status) {
      showTemporaryNotice({ state: true, message: "OTP sent successfully!" });
      setOtpSent(true);
      setShowOtpModal(true);
    } else {
      showTemporaryNotice({ state: true, message: _res.message ?? _res });
    }
  };

  const showTemporaryNotice = (object: any) => {
    setShowNotice(object);
    setTimeout(() => {
      setShowNotice({ state: false, message: "" });
    }, 15000);
  };

  const handleOtpVerified = async (otp: string) => {
    const _res = await PostVerifyOtp({
      phone: form.countryCode + form.mobileNumber,
      otp: otp,
    });
    if (_res.status) {
      setOtpVerified(true);
      setShowOtpModal(false);
      showTemporaryNotice({ state: true, message: "OTP Verified!" });
    } else {
      showTemporaryNotice({ state: true, message: "Invalid OTP." });
    }
  };

  const downloadPdf = async () => {
    const id: string = getLocalItem("schedulePdfId")?.toString() || "";
    const type: string = "s";
    const query = new URLSearchParams({ id, type });
    const apiUrl = host + "admin/pdf?" + query;
    try {
      // Fetch the PDF from the API
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      });

      // Check if the response is OK
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF");
      }

      // Get the PDF blob
      const pdfBlob = await response.blob();

      // Create a link element
      const downloadLink = document.createElement("a");

      // Create an object URL for the blob and set it as the href for the link
      const url = window.URL.createObjectURL(pdfBlob);
      downloadLink.href = url;

      // Set the filename for the downloaded PDF
      downloadLink.download = "generated.pdf";

      // Programmatically click the link to trigger the download
      downloadLink.click();

      // Optionally, revoke the object URL to free memory
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!otpVerified) {
      showTemporaryNotice({
        state: true,
        message: "Please verify OTP before submitting.",
      });
      return;
    }
    try {
      const res = await PostScheduledData(form);
      console.log("API RESPONSE", res);
      if (res?.status) {
        showTemporaryNotice({ state: true, message: res.message });
        console.log("Schedule form submitted:", form);

        setForm({
          employeeName: "",
          requestDate: formatEstDate(getEstDateTime()),
          restaurantLocation: "",
          scheduleChangeRequested: false,
          shiftDropRequested: false,
          dropDate: "",
          dropHours: "",
          replacementName: "",
          shiftPickRequested: false,
          pickDate: "",
          pickHours: "",
          scheduledEmployee: "",
          requestedDayOff: false,
          dayOffFrom: "",
          dayOffTo: "",
          dayOffReason: "",
          isVolunteer: false,
          followingShiftChangeRequest: false,
          followingShiftDate: "",
          followingShiftHoursFrom: "",
          followingShiftHoursTo: "",
          followingShiftPosition: "",
          countryCode: "+1",
          mobileNumber: "",
          acknowledge: false,
        });
        setOtpVerified(false);
        setOtpSent(false);
        setLocalItem("schedulePdfId", res?.id);
        // debugger;
        await downloadPdf();
      } else {
        // console.log("error", res)
        showTemporaryNotice({ state: true, message: res.message ?? res });
      }
    } catch (error: any) { }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-6 max-w-6xl mx-auto p-6 bg-black bg-opacity-40 backdrop-blur rounded-2xl shadow-2xl text-white mt-8 mb-8"
    >
      {/* Headngs */}
      <h2 className="text-xl font-bold text-yellow-300 flex justify-center gap-2">
        <div>
          {/* <i className="fas fa-calendar-check text-yellow-400"></i> */}
          {"Schedule Request Form - New York City".toUpperCase()}
        </div>
      </h2>

      <p className="text-sm text-gray-800 mt-4 text-center font-bold">
        All employee-initiated schedule changes must be approved using this form
        to be completed by the employee and manager at or before the start of
        the schedule change. For changes to general availability, please work
        with your manager to complete the Regular Schedule form.
      </p>

      {/* Main Form */}
      <div className="grid md:grid-cols-2 gap-4">
        {/* <CountryCodeSelect onChange={(code) => setCountryCode(code)} /> */}
        <TextInput
          label="Employee Name (As on the schedule)"
          name="employeeName"
          value={form.employeeName}
          onChange={handleChange}
          placeholder="Employee Name"
          required
        />
        <DateInput
          label="Date of Request"
          name="requestDate"
          value={form.requestDate}
          onChange={handleChange}
          required
          readonly
        />
        <SelectInput
          label="Restaurant Location"
          name="restaurantLocation"
          value={form.restaurantLocation}
          onChange={handleChange}
          required
          options={[
            { value: "2549 - Shore Pkwy", label: "2549 - Shore Pkwy" },
            { value: "105355 - 86 Street", label: "105355 - 86 Street" },
          ]}
        />
      </div>

      {/* Requst Post Schedule */}
      <div className="space-y-2">
        <div className="flex items-center mb-3 px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white">
          <input
            type="checkbox"
            name="scheduleChangeRequested"
            checked={form.scheduleChangeRequested}
            onChange={handleChange}
            className={`w-4 h-4 mr-4  px-3 py-2 cursor-pointer rounded-sm transition-all focus:ring-0 ${form.scheduleChangeRequested
                ? "bg-yellow-400 border-yellow-400"
                : "bg-gray-300 border-gray-400"
              }`}
          />
          <strong>
            I would like to request a change to the posted schedule:
          </strong>
        </div>

        {form.scheduleChangeRequested && (
          <div className="flex gap-4 flex-col border border-gray-500 p-4 rounded-lg">
            <Checkbox
              name="shiftDropRequested"
              checked={form.shiftDropRequested}
              onChange={handleChange}
              label={
                <>
                  I would like to voluntarily drop the following shift(s) or
                  hours from the posted schedule.{" "}
                  <strong>NO MANAGER HAS REQUESTED THIS OF ME.</strong>{" "}
                </>
              }
            />
            {form.shiftDropRequested && (
              <div className="grid md:grid-cols-3 gap-4">
                <DateInput
                  label="Drop Date"
                  name="dropDate"
                  value={form.dropDate}
                  onChange={handleChange}
                  required
                />
                {/* <div className="flex flex-col sm:flex-row gap-4"> */}
                <TimePicker
                  label="Drop "
                  name="dropHours"
                  value={form.dropHours}
                  onChange={(time) => setForm({ ...form, dropHours: time })}
                  required
                />
                {/* </div> */}
                <TextInput
                  label="Replacement Employee"
                  name="replacementName"
                  value={form.replacementName}
                  onChange={handleChange}
                  placeholder="Replacement Employee"
                />
              </div>
            )}
            <Checkbox
              name="shiftPickRequested"
              checked={form.shiftPickRequested}
              onChange={handleChange}
              label={
                <>
                  I would like to voluntarily <strong>pick up</strong> the
                  following shift(s) or hours.{" "}
                  <strong>NO MANAGER HAS REQUESTED THIS OF ME.</strong>
                </>
              }
            />
            {form.shiftPickRequested && (
              <div className="grid md:grid-cols-3 gap-4">
                <DateInput
                  label="Pick Date"
                  name="pickDate"
                  value={form.pickDate}
                  onChange={handleChange}
                />
                {/* <div className="flex flex-col sm:flex-row gap-4"> */}
                <TimePicker
                  label="Pick "
                  name="pickHours"
                  value={form.pickHours}
                  onChange={(time) => setForm({ ...form, pickHours: time })}
                />
                {/* </div> */}
                <TextInput
                  label="Scheduled Employee (if any)"
                  name="scheduledEmployee"
                  value={form.scheduledEmployee}
                  onChange={handleChange}
                  placeholder="Scheduled Employee (if any)"
                />
              </div>
            )}
          </div>
        )}
      </div>

      {/* Days Off Sections */}
      <div className="space-y-2">
        <div className="mb-3 px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white">
          <input
            type="checkbox"
            name="requestedDayOff"
            checked={form.requestedDayOff}
            onChange={handleChange}
            className={`w-4 h-4 mr-4  px-3 py-2 cursor-pointer rounded-sm transition-all focus:ring-0 ${form.scheduleChangeRequested
                ? "bg-yellow-400 border-yellow-400"
                : "bg-gray-300 border-gray-400"
              }`}
          />
          <strong>
            I would like to request the following day(s) off in advance (select
            date(s) in box) (may not be used for already posted schedule):
          </strong>
        </div>

        {form.requestedDayOff && (
          <div className="grid md:grid-cols-3 gap-4  border border-gray-500 p-4 rounded-lg">
            <DateInput
              label="From Date"
              name="dayOffFrom"
              value={form.dayOffFrom}
              onChange={handleChange}
            />
            <DateInput
              label="To Date"
              name="dayOffTo"
              value={form.dayOffTo}
              onChange={handleChange}
            />
            {/* Reason  */}
            <div>
              <label
                htmlFor="dayOffReason"
                className="block text-sm font-medium text-gray-300 mb-1"
              >
                Reason
              </label>
              <textarea
                name="dayOffReason"
                value={form.dayOffReason}
                onChange={handleChange}
                rows={3}
                placeholder="Reason (leave of absence, vacation, days off, etc.)"
                className="w-full border rounded px-3 py-2 text-sm shadow-sm bg-black text-white border-gray-600"
              />
            </div>
            {/* <Checkbox name="isVolunteer" checked={form.isVolunteer} onChange={handleChange} label="Volunteer" /> */}
          </div>
        )}
      </div>

      {/* Following Shifts */}
      <div className="space-y-2">
        <div className="mb-3 px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white">
          <input
            type="checkbox"
            name="followingShiftChangeRequest"
            checked={form.followingShiftChangeRequest}
            onChange={handleChange}
            className={`w-4 h-4 mr-4  px-3 py-2 cursor-pointer rounded-sm transition-all focus:ring-0 ${form.scheduleChangeRequested
                ? "bg-yellow-400 border-yellow-400"
                : "bg-gray-300 border-gray-400"
              }`}
          />
          <strong>
            I would like to be considered to work the following shifts indicated
            on the employee bulletin board as being regularly available to
            existing employees:
          </strong>
        </div>

        {form.followingShiftChangeRequest && (
          <div className="grid md:grid-cols-3 gap-4 w-full  border border-gray-500 p-4 rounded-lg">
            <DateInput
              label="Day(s) of the Week"
              name="followingShiftDate"
              value={form.followingShiftDate}
              onChange={handleChange}
            />
            {/* <div className="flex flex-col sm:flex-row gap-4"> */}

            <TimeInput
              label="Shift Hours From"
              name="followingShiftHoursFrom"
              value={form.followingShiftHoursFrom}
              onChange={handleChange}
            />
            <TimeInput
              label="Shift Hours To"
              name="followingShiftHoursTo"
              value={form.followingShiftHoursTo}
              onChange={handleChange}
            />
            {/* </div> */}
            <TextInput
              label="Position(s) Needed"
              name="followingShiftPosition"
              value={form.followingShiftPosition}
              onChange={handleChange}
              placeholder="Position(s) Needed"
            />
            {/* <Checkbox name="isVolunteer" checked={form.isVolunteer} onChange={handleChange} label="Volunteer" /> */}
          </div>
        )}
      </div>

      <AcknowledgeComponent
        acknowledge={form.acknowledge}
        onAcknowledge={(value) => setForm({ ...form, acknowledge: value })}
      />

      {form.acknowledge && (
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-4">
          <div className="flex flex-col sm:flex-row items-center gap-4">
            {/* <CountryCodeSelect onChange={(code) => setForm({ ...form, countryCode: code })} /> */}

            <NumberInput
              label=""
              name="mobileNumber"
              value={form.mobileNumber}
              onChange={handleChange}
              placeholder="10-digit mobile number"
              minLength={10}
              className="grow-7"
            // required
            />

            <button
              type="button"
              onClick={handleSendOtp}
              className="bg-yellow-500 flex-none  text-black font-bold px-4 py-2 rounded-lg shadow hover:bg-yellow-600 transition"
            >
              {otpSent ? "Resend OTP" : "Send OTP"}
            </button>
          </div>

          <button
            type="submit"
            className={`px-6 py-2 rounded-lg font-bold transition ${otpVerified
                ? "bg-green-500 text-black hover:bg-green-600"
                : "bg-gray-500 text-gray-300 cursor-not-allowed"
              } w-full sm:w-auto`}
            disabled={!otpVerified}
          >
            Submit Schedule Request
          </button>
        </div>
      )}

      <OtpModal
        show={showOtpModal}
        phone={form.mobileNumber}
        onClose={() => setShowOtpModal(false)}
        onVerify={handleOtpVerified}
        onResend={async () => {
          await handleSendOtp();
          // showTemporaryNotice({ state: true, message: "Resend triggered" });
        }}
      />
      <NotificationModal
        show={showNotice.state}
        onClose={() => setShowNotice({ state: false, message: "" })}
        message={showNotice.message}
      />
    </form>
  );
};

export default ScheduleRequestForm;
